import { render } from "./vpartnerlist.vue?vue&type=template&id=210c4e9a&scoped=true"
import script from "./vpartnerlist.vue?vue&type=script&lang=js"
export * from "./vpartnerlist.vue?vue&type=script&lang=js"

import "./vpartnerlist.vue?vue&type=style&index=0&id=210c4e9a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210c4e9a"]])

export default __exports__